module.exports = __webpack_public_path__ + "static/media/expresslogo.3870d8ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/expresslogo.svg
// module id = 818
// module chunks = 0